import * as React from 'react';
import Button from '@mui/material/Button';
import { Tooltip } from '@mui/material';

export default function DisabledModuleButton(props) {
  return (
    <Tooltip
    arrow
    title={<h3>{props.title}</h3>}
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: 'white',
          '& .MuiTooltip-arrow': {
            color: '#006E90',
          },
          color: '#006E90',
          border: '1px solid',
          borderColor: '#006E90',
        },
      },
    }}
    >
      <div>
        <Button
          sx={{
            color: '#006E90',
            border: '2px solid',
            paddingX: 4,
            paddingY: 2,
            boxShadow: 3,
            width: '100%',
            variant: 'outlined',
            justifyContent: 'space-between',
            '&:hover': {
              backgroundColor: '#F18F01',
              color: 'white',
              borderColor: '#006E90',
            },
          }}
          {...props}
        >
          {props.children}
        </Button>
      </div>
    </Tooltip>
  );
}
